'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Objects = require('../util/Objects');

var _Analytics = require('../util/Analytics');

var _Analytics2 = _interopRequireDefault(_Analytics);

var _Severity = require('../constants/Severity');

var _Severity2 = _interopRequireDefault(_Severity);

var _EventGroups = require('../constants/EventGroups');

var _EventGroups2 = _interopRequireDefault(_EventGroups);

var _Cookies = require('../util/Cookies');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_CTA_TEXT = 'View status page';

var Alarm = function () {
  function Alarm(alarmData, dom, storage, events, date) {
    _classCallCheck(this, Alarm);

    (0, _Objects.objectAssign)(this, alarmData);

    this.dom = dom;
    this.storage = storage;
    this.events = events;

    this.date = date || Date;
    this.severity = _Severity2.default.getByKey(alarmData.severity);

    var id = this.id || this.uuid;
    this.alarmId = 'alarm.' + id + '.revision.' + this.revisionNumber;
    this.className = 'Alarm';
    this.storageKey = 'firealarm.dismiss.' + this.alarmId;
    this.analyticsKey = 'firealarm.analytics.' + this.alarmId;
    this.domElement = null;

    this.alarmElementId = 'firealarm-' + (this.id || this.date.now());
    this.alarmDismissButtonId = this.alarmElementId + '-dismiss';
  }

  _createClass(Alarm, [{
    key: 'dismiss',
    value: function dismiss() {
      _Analytics2.default.trackUsage('dismiss-alarm-clicked', this.id, this.revisionNumber);

      this.storage.setItem(this.storageKey, "true");
      if (this.domElement) {
        var parent = this.domElement.parentNode;
        parent.removeChild(this.domElement);

        if (!parent.hasChildNodes()) {
          parent.parentNode.removeChild(parent);
        }
      }

      this.events.runEvents(_EventGroups2.default.ON_DISMISS_ALARM, this);
    }
  }, {
    key: 'getDomElement',
    value: function getDomElement() {
      var _this = this;

      if (!this.domElement) {
        var ctaText = this.callToAction && this.callToAction.ctaText || DEFAULT_CTA_TEXT;

        this.domElement = this.dom.createElementFromHtml('<div\n          id="' + this.alarmElementId + '"\n          class="fire-alarm_alarm fire-alarm_' + this.severity.key.toLowerCase() + '"\n          role="alert"\n          aria-live="assertive"\n          aria-atomic="true" >\n            <div class="fire-alarm_alarm-inner">\n              <div class="fire-alarm_alarm-body">\n                <h2>' + this.title + '</h2>\n                <p>' + this.message + '</p>\n              </div>\n            </div>\n        </div>');

        if (this.callToAction) {
          var callToActionLink = this.dom.createElementFromHtml('<a class="fire-alarm_alarm-status-page-link" href="' + this.callToAction.url + '" target="_blank">' + ctaText + '</a>');
          this.domElement.appendChild(callToActionLink);

          callToActionLink.addEventListener('click', this.trackCtaClick.bind(this));
        }

        var dismissButton = this.dom.createElementFromHtml('<button id=' + this.alarmDismissButtonId + ' type="button" data-action="close" class="fire-alarm_alarm-close-button">\n          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" class="alarm-close-icon">\n            <path transform="translate(-1 -1)" d="M14.5,1.5l-13,13m0-13,13,13"></path>\n          </svg>\n          <span class="fire-alarm_alarm-button-text">Close</span>\n        </button>');

        this.domElement.appendChild(dismissButton);

        // wire up dismiss button
        // This should handle click and touch events
        if (dismissButton) {
          var onDismissButton = function onDismissButton(event) {
            event.preventDefault();
            _this.dismiss();
          };

          dismissButton.addEventListener('touchend', onDismissButton);
          dismissButton.addEventListener('click', onDismissButton);
        }
      }

      return this.domElement;
    }
  }, {
    key: 'isDismissed',
    value: function isDismissed() {
      return this.storage.getItem(this.storageKey) === "true";
    }
  }, {
    key: 'hasTrackedViewEventToday',
    value: function hasTrackedViewEventToday() {
      return (0, _Cookies.getCookie)(this.analyticsKey);
    }
  }, {
    key: 'trackViewEventIfNotTrackedToday',
    value: function trackViewEventIfNotTrackedToday() {
      if (!this.hasTrackedViewEventToday()) {
        _Analytics2.default.trackUsage('viewed-fire-alarm', this.id, this.revisionNumber);

        var midnight = new Date().setHours(23, 59, 59, 59).valueOf();
        var now = new Date().valueOf();
        (0, _Cookies.setCookie)(this.analyticsKey, true, midnight - now);
      }
    }
  }, {
    key: 'trackCtaClick',
    value: function trackCtaClick() {
      _Analytics2.default.trackUsage('clicked-cta', this.id, this.revisionNumber);
    }
  }]);

  return Alarm;
}();

exports.default = Alarm;
module.exports = exports['default'];